import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider, ConnectButton } from '@rainbow-me/rainbowkit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from './config/wagmi';
import { Home } from './pages/Home';
import { Profile } from './pages/Profile';
import { ProfileSetup } from './pages/ProfileSetup';
import { BookView } from './pages/BookView';
import { CreatePage } from './pages/CreatePage';
import { Footer } from './components/Footer';
import './App.css';

const queryClient = new QueryClient();

function Navbar() {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <span>📖</span>
          <span>₿ook of Secrets</span>
        </Link>

        <div className="navbar-menu">
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link
            to="/profile"
            className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
          >
            Profile
          </Link>
          <Link
            to="/book"
            className={`nav-link ${isActive('/book') ? 'active' : ''}`}
          >
            My ₿ook
          </Link>
          <Link
            to="/create"
            className={`nav-link ${isActive('/create') ? 'active' : ''}`}
          >
            Create
          </Link>

          <ConnectButton
            accountStatus="avatar"
            chainStatus="icon"
            showBalance={false}
          />
        </div>
      </div>
    </nav>
  );
}

function AppRoutes() {
  return (
    <div className="app-container">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:address" element={<Profile />} />
        <Route path="/profile-setup" element={<ProfileSetup />} />
        <Route path="/book" element={<BookView />} />
        <Route path="/book/:address" element={<BookView />} />
        <Route path="/create" element={<CreatePage />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <Router>
            <AppRoutes />
          </Router>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
